import { useEffect } from 'react';
import { useAuth, useClerk } from '@clerk/clerk-react';
import { apiClient } from '@/services/api-client';
import { useError } from '@/hooks/useError';

interface ApiClientProviderProps {
  children: React.ReactNode;
}

export function ApiClientProvider({ children }: ApiClientProviderProps) {
  const { getToken } = useAuth();
  const { signOut } = useClerk();
  const { showError } = useError();

  useEffect(() => {
    // Initialize the API client with Clerk's functions
    if (getToken) {
      apiClient.setTokenGetter(getToken);
    }
    
    if (signOut) {
      apiClient.setSignOutFunction(() => {
        signOut();
      });
    }

    // Set error handler
    apiClient.setErrorHandler(showError);
  }, [getToken, signOut, showError]);

  return <>{children}</>;
}